import { render, staticRenderFns } from "./pagamentos.vue?vue&type=template&id=ac10e09c&"
import script from "./pagamentos.vue?vue&type=script&lang=js&"
export * from "./pagamentos.vue?vue&type=script&lang=js&"
import style0 from "./pagamentos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports